export class JiraResult {
    public statusName: string;
    public summary: string;
    public reporterName: string;
    public assigneeName: string;
    public resolutionShortDate: string;
    public createdDate: string;
    public createdShortDate: string;
    public url: string;
    public projectName: string;
    public issueTypeName: string;
    public resolutionName: string;
    public requestTypeName: string;
    public elapsedTime: number;
    public breachDate: string;
    public closedDate: string;
    public total: number;
    public updatedShortDate: string;
    public key: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dashboards/jira-result.ts